import ManageBookingContainer from './ManageBookingModal.container';
export default ManageBookingContainer;